import { Navigate, Outlet } from "react-router-dom";
import { RoutePath } from "@/routes";
import { accountApi } from "@/resources/account";
import FullScreenLoader from "@/components/ui/full-screen-loader";
import { ACCOUNT_ROLE } from "@/constants/account";

export default function AdminRoute() {
  const { data: account, isLoading } = accountApi.useGetAccount();

  if (isLoading) {
    return <FullScreenLoader />;
  }

  if (
    account?.role === ACCOUNT_ROLE.OWNER ||
    account?.role === ACCOUNT_ROLE.ADMIN
  ) {
    return <Outlet />;
  }

  return <Navigate to={RoutePath.Dashboard} replace />;
}
